export class ScriptLoader {
  private static loadedScripts: Set<string> = new Set();

  static isScriptLoaded(src: string): boolean {
    return ScriptLoader.loadedScripts.has(src);
  }

  static loadScript(src: string): Promise<HTMLScriptElement> {
    return new Promise((resolve, reject) => {
      // Check if already loaded
      if (ScriptLoader.isScriptLoaded(src)) {
        resolve(document.querySelector(`script[src="${src}"]`) as HTMLScriptElement);
        return;
      }

      // Check if script element already exists in DOM
      const existingScript = document.querySelector(`script[src="${src}"]`) as HTMLScriptElement;
      if (existingScript) {
        ScriptLoader.loadedScripts.add(src);
        resolve(existingScript);
        return;
      }

      // Create new script element
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = src;
      script.async = true;

      script.onload = () => {
        ScriptLoader.loadedScripts.add(src);
        resolve(script);
      };

      script.onerror = () => {
        reject(new Error(`Failed to load script: ${src}`));
      };

      document.head.appendChild(script);
    });
  }
}